import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    inboxList: {},
    inboxNotification: {},
};

const InboxSlice = createSlice({
    name: 'inboxlist',
    initialState,
    reducers: {
        setInboxList(state, action) {
            state.inboxList = action.payload;
        },
        setToast(state, action) {
            state.inboxNotification = action.payload;
        },
        // setToast(state, action) {
        //     state.notification = action.payload;
        // },

    },
});



export const InboxListApi = (tokendata, page, limit) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/publisher/inbox?page=${page}&limit=${limit}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setInboxList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}


export const { setInboxList, setToast } = InboxSlice.actions;
const InboxReducer = InboxSlice.reducer;

export default InboxReducer;
